import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import Grid from 'apollo-react/components/Grid';
import Paper from 'apollo-react/components/Paper';
import Table from 'apollo-react/components/Table';
import Plus from 'apollo-react-icons/Plus';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import DeleteActionCell from './DeleteActionCell';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { INCLUDED_ACTORS_TABLE_KEY } from '../../constants/export.constants';
import LookupField from '../controls/LookupField';

const useStyles = makeStyles({
  addButtonContainer: {
    textAlign: 'right',
    marginTop: '8px !important',
  },
  controlWrapper: {
    position: 'relative',
    margin: '5px 0px',
  },
});

const columns = [
  {
    header: 'Code',
    accessor: 'code',
    width: '50%',
    customCell: ({ row }) => (
      <LookupField
        rowId={row.rowId}
        entityName="Actor"
        savedSearchName=""
        actorsTableKey={row.actorsTableKey}
        handleSelect={row.handleZoomSelect}
        value={row.code}
        multiSelect={row.multiSelect}
      />
    ),
  },
  {
    header: 'Name',
    accessor: 'name',
  },
  {
    accessor: 'action',
    customCell: ({ row }) => <DeleteActionCell row={row} />,
    align: 'right',
    width: 55,
  },
];

const ActorsTable = ({
  rows = [],
  actorsTableKey,
  handleAddActor,
  handleSelectActor,
  handleDeleteActor,
  multiSelect,
  isAddDisabled,
}) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const handleAddNewRow = () => {
    const tmpRowId = uuidv4();

    const newRow = {
      rowId: tmpRowId,
      id: tmpRowId,
      code: '',
      name: '',
    };

    handleAddActor({ actorsTableKey, newRow });
  };

  const disabledAddButton =
    (actorsTableKey === INCLUDED_ACTORS_TABLE_KEY && rows.length > 0) || isAddDisabled;

  return (
    <Grid container spacing={1}>
      <Grid classes={{ item: classes.addButtonContainer }} item xs={12}>
        {
          <Button
            color="primary"
            variant="secondary"
            onClick={handleAddNewRow}
            disabled={disabledAddButton}
          >
            <Plus fontSize="small" />
            &nbsp;
            {translateString('Add')}
          </Button>
        }
      </Grid>
      <Grid item xs={12}>
        <Paper square>
          <Table
            columns={columns}
            emptyProps={{
              text: translateString('No data to display'),
            }}
            rowId="rowId"
            rows={rows.map((row) => ({
              ...row,
              actorsTableKey,
              deleteRow: handleDeleteActor,
              handleZoomSelect: handleSelectActor,
              multiSelect,
              translateString,
              classes,
              rows,
            }))}
            rowsPerPageOptions={[5, 10, 20, translateString('All')]}
            defaultRowsPerPage={5}
            hidePagination={actorsTableKey === INCLUDED_ACTORS_TABLE_KEY}
            showFilterIcon
            tablePaginationProps={{
              labelDisplayedRows: ({ from, to, count }) =>
                `${from}-${to} ${translateString('of')} ${count}`,
              truncate: true,
              labelRowsPerPage: translateString('Rows'),
              pageText: translateString('Page'),
              ofText: translateString('of'),
            }}
          />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default ActorsTable;
